import {Temp} from "../utils/Temp.js";
import {msg} from "@/i18n/Message.ts";

export class SymbolicCalendarWidget {
	constructor() {
		this.listeners = [];
	}

	addSymbolicPickListener(listener) {
		this.listeners.push(listener);
	}

	get ui() {
		if (this.root == null) this.rebuild();
		return this.root;
	}

	rebuild() {
		this.root = Temp.tag('div', {clazz: 'dt-symbolic'});
		this.root.append(this.createAnchorSelect());
		this.root.append(this.createTypeSelect());
		this.root.append(this.createShiftField());
	}

	createAnchorSelect() {
		const ops = {};
		ops.items = [
			{ name: msg("date.picker.now"), value: "NOW" },
			{ name: msg("date.picker.beginning"), value: "START" },
			{ name: msg("date.picker.end"), value: "END" }
		];
		this.anchorSelect = Temp.select(ops);
		this.anchorSelect.on("change", this.change.bind(this));
		return this.anchorSelect;
	}

	createTypeSelect() {
		const ops = { style: 'margin-top:4px' };
		ops.items = [
			{ name: "-", value: "" },
			{ name: msg("date.picker.day"), value: "D" },
			{ name: msg("date.picker.weekFromMonday"), value: "WM" },
			{ name: msg("date.picker.weekFromSunday"), value: "WS" },
			{ name: msg("date.picker.month"), value: "M" },
			{ name: msg("date.picker.quarter"), value: "Q" },
			{ name: msg("date.picker.year"), value: "Y" },
		];
		this.typeSelect = Temp.select(ops);
		this.typeSelect.on("change", this.change.bind(this));
		return this.typeSelect;
	}

	createShiftField() {
		const d = Temp.tag("div", { style: 'margin-top:4px' });
		d.append(document.createTextNode(msg("date.picker.shift")+": "));
		this.shiftInput = $("<input type='number' maxlength='4' size='3' min='-999' max='999' value='0'>");
		d.append(this.shiftInput);
		this.shiftInput.on("change", this.change.bind(this));
		return d;
	}

	change() {
		this.fire();
		this.enable();
	}

	fire() {
		const val = this.format();
		for (let listener of this.listeners) {
			listener(val);
		}
	}

	enable() {
		if (this.anchorSelect.val() === 'NOW') {
			this.typeSelect.val("");
			this.shiftInput.val("0");
			this.typeSelect.attr("disabled", "disabled");
			this.shiftInput.attr("disabled", "disabled");
		} else {
			this.typeSelect.removeAttr("disabled");
			this.shiftInput.removeAttr("disabled");
		}
	}

	format() {
		const anchor = this.anchorSelect.val();
		if ("NOW" === anchor) return "NOW()";
		else {
			let formatted = this.typeSelect.val();
			if (formatted.length === 0) formatted = "M";
			let s = this.shiftInput.val();
			if (s.trim() === "0") s = "";
			formatted = formatted + anchor + "(" + s + ")";
			return formatted;
		}
	}

	/**
	 * @param {string} value
	 */
	parse(value) {
		let data = value.toUpperCase().trim();
		let sym = data.substring(0, data.indexOf("("));
		let shift = data.substring(data.indexOf("(")+1, data.indexOf(")"));
		if (sym === 'NOW') {
			this.anchorSelect.val("NOW");
			this.typeSelect.val("");
			this.shiftInput.val("0");
		} else {
			let type, anchor;
			if (sym.startsWith("W")) {
				type = sym.substring(0, 2);
				anchor = sym.substring(2);
			} else {
				type = sym.substring(0, 1);
				anchor = sym.substring(1);
			}
			if (shift.length === 0) shift = "0";
			this.anchorSelect.val(anchor);
			this.typeSelect.val(type);
			this.shiftInput.val(shift);
		}
		this.enable();
	}
}
